import { useState } from 'react';
import { useSnackbar } from 'notistack';
// @mui
import {
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../components/Iconify';
// hooks
import useResponsive from '../../hooks/useResponsive';
// utils
import axios from '../../utils/axios';

export default function AIProfileConfirmDialog({ isOpen, closeDialog, reload }) {
  const smUp = useResponsive('up', 'sm');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const deleteAIProfile = async () => {
    try {
      setIsSubmitting(true);
      await axios.post(`/api/crews/ai/intro/decline/`);
      reload();
      setIsSubmitting(false);
      enqueueSnackbar('AI 크루 소개가 삭제되었습니다. ', { variant: 'error' });
      closeDialog();
    } catch (err) {
      console.error(err);
      setIsSubmitting(false);
    }
  }

  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 24, height: 24, color: 'error.main' }} />
        <Typography variant={smUp ? "h5" : "subtitle1"}>
          AI 크루 소개 내용을 삭제할까요?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <LoadingButton
          size="large"
          onClick={closeDialog}
          loading={isSubmitting}
        >
          취소
        </LoadingButton>
        <LoadingButton
          variant="contained"
          onClick={deleteAIProfile}
          size="large"
          sx={{ px: 3 }}
          loading={isSubmitting}
        >
          삭제하기
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
};
